<template>
  <div class="min-w-8">

    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.32 51.64">
      <path
        d="M2.41,38.2c-1.29-2.07-2.18-4.87-2.18-7.67s1.51-7,3.47-10.64c2.46-4.31,5.43-6.83,8.51-6.83s4.59,2.3,4.59,6.72c0,1.51-.34,2.8-.84,3.92-.84,1.57-2.02,2.35-3.64,2.35-1.34,0-2.02-1.01-2.02-2.91,0-.62.28-1.68.56-2.58.17-.5.34-.95.45-1.34-.28.06-.56.17-.9.39-1.57.78-2.97,2.24-4.14,4.42v-.06c-1.12,2.02-1.62,4.03-1.62,6.05,0,3.64,2.52,5.93,6.16,5.93.9,0,1.79-.34,2.74-.9v.06c.5-.39,1.23-1.12,1.96-1.85.78-.9,1.4-1.51,1.96-1.51.9,0,1.34.84,1.34,2.46,0,.73.06,1.12-.06,1.51-.11.67-.5,1.62-1.23,2.35v-.06c-2.35,2.63-4.98,4.03-7.95,4.03s-5.43-1.34-7.17-3.86Z" />
    </svg>
  </div>
</template>